import actionTypes from '../constants/action-types';

const getDomainListFailure = () => ({
  type: actionTypes.GET_DOMAIN_LIST_FAILURE,
});

export default getDomainListFailure;
